import {getCorpTagIds} from 'crm/components/tags-modal/utils'

export function filterTagParams(key, query) {
    if (query.hasOwnProperty(key)) {
        if (!query[key]?.values?.length) {
            delete query[key]
            return
        }
        if (key === 'corp_tags') {
            query[key].values = getCorpTagIds(query[key].values)
        }
    }
}
